
import { Validatable } from "../mixins/validatable";

export default Validatable.extend({
	props: {
		value: Boolean,
		label: String,
		disabled: Boolean,
		reverse: Boolean,
		space: Boolean,
	},
	computed: {
		elementId():string {
			return "w-switch-" + (this as any)._uid;
		},
		inputElement():HTMLInputElement {
			return this.$refs.inputElement as HTMLInputElement;
		}
	},
	created() {
		this.$emit("id", this.elementId);
	},
	methods: {
		input() {
			if (this.disabled) return;
			this.$emit("input", this.inputElement.checked);
		},
		switchClicked() {
			if (this.disabled) return;
			this.inputElement.checked = !this.inputElement.checked;
			this.input();
		}
	}
});
